import DOMPurify from 'dompurify';

import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Send Report Abuse
 * @param {object} params - An object of params
 * @param {string} params.accessToken - User IMS token
 * @param {string} params.category - Report abuse category
 * @param {string} params.description - Description about report abuse
 * @param {string} params.appId -  Id of the app
 * @param {string} params.appType -  Type of the app
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['accessToken', 'category', 'description', 'appId', 'appType'];
  const paramsRules = {
    category: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
    description: { allowedTypes: ['string'] },
    appId: { allowedTypes: ['string'] },
    appType: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${settings.endpoint}/v2/support/sendEmail`, {
    signal,
    method: 'POST',
    headers: {
      'x-api-key': settings.apiKey,
      'Content-type': 'application/json',
      Authorization: params.accessToken,
    },
    body: JSON.stringify({
      category: params.category,
      description: DOMPurify.sanitize(params.description),
      templateName: 'ABUSE_TEMPLATE',
      appId: params.appId,
      appType: params.appType,
    }),
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }
  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return true;
  }
};
